<template>
    <div>
        <download :src="src"></download>
        <div class="pdf-view" ref="pdf-view" :style="{ 'height': containerHeight + 'px' }">
            <div v-if="error" class="d-flex h-100 w-100 align-items-center justify-content-center">
                <div>{{error}}</div>
            </div>
            <template v-if="isInitComplete">
                <div ref="canvas-container"></div>
                <div v-if="loading" v-loading="loading"></div>
            </template>
            <div v-else v-loading="true" class="h-100 w-100">
            </div>
        </div>
    </div>
</template>

<script>
    // import * as pdfjs from 'pdfjs-dist'
    import * as pdfjs from 'pdfjs-dist/es5/build/pdf'
    // import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry'
    import pdfjsWorker from 'pdfjs-dist/es5/build/pdf.worker.entry'
    import { sleep } from '../../common/utils/sleep.util'
    import Download from '../common/Download'

    pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker

    export default {
        name: 'PdfView',
        components: { Download },
        props: {
            src: {
                type: String,
                required: true
            }
        },
        data () {
            return {
                containerHeight: 0,
                numPages: 0,
                pdfDoc: null,
                loadStep: 5,
                numPagesLoaded: 0,
                isInitComplete: false,
                options: {
                    scale: 1
                },
                sleepTime: 2000,
                loading: false,
                scrollDistance: 50,
                error: null
            }
        },
        methods: {
            async loadPdf () {
                try {
                    if (!this.src) {
                        return
                    }

                    const loadingTask = pdfjs.getDocument(this.src)
                    const pdfDoc = await loadingTask.promise.then(pdfDoc => pdfDoc)
                    this.pdfDoc = pdfDoc
                    this.numPages = pdfDoc.numPages
                    this.isInitComplete = true
                    this.$emit('loaded')
                    this.$nextTick(() => {
                        this.addEventScroll()
                        this.infiniteHandler()
                    })
                } catch (e) {
                    this.error = 'ファイルが読み込めませんでした。'
                }
            },
            renderPages (from, to) {
                const _self = this
                const canvasContainer = this.$refs['canvas-container']
                function renderPage (page) {
                    return new Promise(resolve => {
                        const devicePixelRatio = window.devicePixelRatio || 1

                        const scale = canvasContainer.offsetWidth / page.getViewport(_self.options).width
                        const viewport = page.getViewport({ scale })

                        const canvas = document.createElement('canvas')
                        const context = canvas.getContext('2d')

                        canvas.style.width = viewport.width + 'px'
                        canvas.style.height = viewport.height + 'px'

                        canvas.height = viewport.height * devicePixelRatio
                        canvas.width = viewport.width * devicePixelRatio

                        const transform = [devicePixelRatio, 0, 0, devicePixelRatio, 0, 0]
                        const renderContext = {
                            canvasContext: context,
                            viewport,
                            transform
                        }

                        canvasContainer.appendChild(canvas)
                        const renderTask = page.render(renderContext)
                        renderTask.promise.then(() => {
                            resolve()
                        })
                    })
                }

                let p = Promise.resolve()
                for (let num = from; num <= to; num++) {
                    p = p.then(() => this.pdfDoc.getPage(num).then(renderPage))
                }
                return p
            },
            infiniteHandler () {
                this.loading = true
                const from = this.numPagesLoaded + 1
                const to = this.numPagesLoaded + this.loadStep <= this.numPages ? this.numPagesLoaded + this.loadStep : this.numPages

                this.renderPages(from, to)
                    .then(() => {
                        return to < this.numPages ? sleep(this.sleepTime) : null
                    })
                    .then(() => {
                        this.numPagesLoaded = to
                        this.loading = false
                    })
            },
            handleScroll (e) {
                if (this.noMore) {
                    this.removeEventScroll()
                    return
                }

                if (this.loading) {
                    return
                }

                const pdfView = this.$refs['pdf-view']
                const canvasContainer = this.$refs['canvas-container']

                if (pdfView.scrollTop + pdfView.offsetHeight + this.scrollDistance >= canvasContainer.offsetHeight) {
                    this.infiniteHandler()
                }
            },
            addEventScroll () {
                const pdfView = this.$refs['pdf-view']
                pdfView.addEventListener('scroll', this.handleScroll)
            },
            removeEventScroll () {
                const pdfView = this.$refs['pdf-view']
                pdfView.removeEventListener('scroll', this.handleScroll)
            }
        },
        computed: {
            noMore () {
                return this.numPagesLoaded >= this.numPages
            },
            disabled () {
                return this.loading || this.noMore
            }
        },
        mounted () {
            const pdfView = this.$refs['pdf-view']
            const offsetWidth = pdfView.offsetWidth
            this.containerHeight = Math.round((297 / 210) * offsetWidth)
            this.$nextTick(() => {
                this.loadPdf()
            })
        },
        beforeDestroy () {
            this.removeEventScroll()
        }
    }
</script>

<style scoped>
    .pdf-view {
        overflow-y: auto;
        border: 1px solid #000;
    }
</style>
